import SecureAxios from './SecureAxios';

class TaskService {
  getTasks(filterStates) {
    return SecureAxios.get('/server/api/v1/tasks');
  }
}

export default new TaskService();
